import { Typography } from '@material-ui/core';
import React from 'react';

import { Box, Card, Col, Link, Row, ViewContainer } from 'components/AORedesign';
import {
  UserAdminAddUserLink,
  UserAdminDeleteDuplicateEmailLink,
  UserAdminEditUserLink,
  UserAdminGroupInfoLink,
  UserAdminViewAgencyInfoLink,
  UserAdminViewChangeHistoryLink,
} from 'components/AORedesignViews/UserAdmin';
import { Feature } from 'components/Feature';
import featureFlags from 'constants/featureFlags';

const UserAdminHome = () => {
  return (
    <Feature allowed={featureFlags.ACCESS_AGENCY_SECURITY_USER_ADMIN}>
      <ViewContainer title="User Administration" hidePolicyViewChange hideStartQuote>
        <Box mb={2}>
          <Card>
            <Row spacing={4}>
              <Col xs={4}>
                <Typography color="textSecondary">
                  Welcome to the MSA Web Security Administration Home Page. The links to the right offer access to all of the resources you need to review or
                  edit user information.
                </Typography>
              </Col>
              <Col xs={4}>
                <Box mb={4}>
                  <UserAdminAddUserLink />
                  <Typography color="textSecondary">From this screen you may add users to your agency.</Typography>
                </Box>
                <Box mb={4}>
                  <UserAdminEditUserLink />
                  <Typography color="textSecondary">
                    From this page you may find the users in your agency and edit their agencies, groups, or individual information.
                  </Typography>
                </Box>
                {/* Hiding links under https://amfament.atlassian.net/browse/E1PMAO-13450 while training team works on getting new links. No timeframe */}
                <Feature allowed={[]}>
                  <Box>
                    <Link href="" endIcon="openInNew">
                      Website Security Guide
                    </Link>
                  </Box>
                </Feature>
              </Col>
              <Feature allowed={featureFlags.ACCESS_USER_ADMIN}>
                <Col xs={4}>
                  <Box mb={4}>
                    <UserAdminViewAgencyInfoLink />
                    <Typography color="textSecondary">From this screen you may view agency information.</Typography>
                  </Box>
                  <Box mb={4}>
                    <UserAdminGroupInfoLink />
                    <Typography color="textSecondary">From this page you may view information about groups.</Typography>
                  </Box>
                  <Box mb={4}>
                    <UserAdminViewChangeHistoryLink />
                    <Typography color="textSecondary">From this screen you may view the changes to a user&apos;s account.</Typography>
                  </Box>
                  <Feature allowed={featureFlags.ACCESS_SUPER_ADMIN}>
                    <Box mb={4}>
                      <UserAdminDeleteDuplicateEmailLink />
                      <Typography color="textSecondary">From this screen you may search for an email tied to a duplicate account and delete it.</Typography>
                    </Box>
                  </Feature>
                </Col>
              </Feature>
            </Row>
          </Card>
        </Box>
      </ViewContainer>
    </Feature>
  );
};

export default UserAdminHome;
